import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { ReadMoreBox } from 'Layout'
import Collapsible from 'Components/Collapsible'
import NearbyMapCta from 'Components/NearbyMapCta'
import { _Container, _DescriptionContainer, _DescCircleMapContainer, _TextContainer } from './styles'

const DescriptionCircleMap = (
  {
    isFetching,
    description,
    descriptions,
    descMaxHeight = 116,
    handleKeyPress,
    handleClick,
    buildingName,
    descClass = '',
    readMoreToggle,
    collapsibleIdSuffix,
  }) => (
  /* eslint-disable-next-line */
  <_DescCircleMapContainer>
    <Collapsible
      inputId={`Overview-${collapsibleIdSuffix}`}
      openCollapseTargetId={`Overview-${collapsibleIdSuffix}`}
      title={buildingName ? `${buildingName} Overview` : 'Overview'}
      gaActionTitle={'Building Overview'}
      seoText={
        `Learn about ${buildingName || ''}`
      }
      defaultShowState
      isCollapsible
      showSeparatorLine
    >
      <_DescriptionContainer>
        <_TextContainer>
          <ReadMoreBox
            body={
              ((descriptions && descriptions.intro))
              || description
              || `Description For ${buildingName || 'The Building'} Is Coming Soon`}
            bodyMaxHeight={descMaxHeight}
            bodyClass={descClass}
            isFetching={isFetching}
            readMoreToggle={readMoreToggle}
          />
        </_TextContainer>
        <_Container>
          <NearbyMapCta
            sideBarStyle
            handleMapClick={handleClick}
            showDirectionCaption
            onKeyPress={handleKeyPress}
          />
        </_Container>
      </_DescriptionContainer>
    </Collapsible>
  </_DescCircleMapContainer>
)

DescriptionCircleMap.propTypes = {
  descriptions: PropTypes.oneOfType([
    PropTypes.shape({
      intro: PropTypes.string,
    }),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
  descMaxHeight: PropTypes.number,
  descClass: PropTypes.string,
  handleClick: PropTypes.func,
  handleKeyPress: PropTypes.func,
  address: PropTypes.shape({}),
  isFetching: PropTypes.bool,
  description: PropTypes.string,
  buildingName: PropTypes.string,
  readMoreToggle: PropTypes.func,
  collapsibleIdSuffix: PropTypes.string,
}

export default memo(DescriptionCircleMap)
